// ** Third Party Imports
import styled from 'styled-components'

// ** Utility Imports
import { media } from '@/shared/styles'

// ** Component Imports
import { Heading, Typography } from '@/shared/ui'

export const HeaderWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	column-gap: 1rem;
	align-items: flex-start;
	justify-content: space-between;

	& > div:nth-child(2) {
		margin-bottom: 1rem;
	}
`

export const StyledSubtitle = styled(Heading)`
	margin-bottom: 0.5rem;
`

export const StyledDescription = styled(Typography)`
	margin-bottom: 1.5rem;
`

export const ChartSection = styled.div`
	gap: 1.5rem;
	display: flex;
	margin-bottom: 1.5rem;

	${media.xl} {
		flex-wrap: wrap;
	}

	& > div:first-child {
		flex: 1 1 25%;

		${media.lg} {
			flex-basis: 100%;
		}
	}

	& > div:nth-child(2) {
		flex: 1 1 25%;

		${media.lg} {
			flex-basis: 100%;
		}
	}

	& > div:nth-child(3) {
		flex: 1 1 50%;
	}
`

export const PlanSection = styled.div`
	gap: 1.5rem;
	display: flex;
	margin-top: 1.5rem;
	flex-wrap: wrap;

	& > div {
		flex: 1 1 25rem;
	}
`
